<div class="app-component-container costum-mat-primary-container" id="image-gallery">
  <div class="content">
      <app-s-header [elemIds]="elementSignals['component-header']()"></app-s-header>
  </div>
  <app-base-image-gallery [elemIds]="elementSignals['gallery-config']()"></app-base-image-gallery>



</div>